<script>
import FormBlock from '@/components/FormBlock.vue';
import BaseTable from '@/components/base/BaseTable.vue';
import BaseTableCell from '@/components/base/BaseTableCell.vue';
import AdminUserListTileCell from '@/components/admin/list/AdminUserListTileCell.vue';
import BaseTableEventCell from '@/components/base/BaseTableEventCell.vue';
// import CarouselArrows from '@/components/ui/CarouselArrows.vue';

export default {
  name: 'UserDetailTableTile',
  components: {
    FormBlock,
    BaseTable,
    BaseTableCell,
    AdminUserListTileCell,
    // CarouselArrows,
  },
  props: {
    headers: Array,
    items: Array,
    label: String,
  },
  computed: {
    components() {
      return { AdminUserListTileCell, BaseTableCell, BaseTableEventCell };
    },

    headersWithComponents() {
      return this.headers.map(h => ({
        ...h,
        component: { is: this.components[h.component], props: h.props, sortFn: h.sortFn || null },
      }));
    },
  },
};
</script>

<template lang="pug">
FormBlock(mobile)
  .b-user-detail-table-tile
    ._header
      ._label {{ label }}
      //CarouselArrows
    BaseTable._table(:headers="headersWithComponents" :items="items")
</template>

<style scoped lang="scss">
.user-detail-table-tile {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 6px;
    border-bottom: 1px solid rgb(235, 239, 242);
  }

  &__table {
    padding-top: 25px;
  }
}
</style>
